import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { collection, getDocs, query, where } from "firebase/firestore";
import db from "../../firebase";
import styles from "./MyAccount.module.css";
import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import cld from "../../cloudinary";
import { AdvancedImage } from "@cloudinary/react";

const MadeSection = () => {
  const loggedUser = useSelector((state) => state.loggedUser);
  const [bids, setBids] = useState();

  useEffect(() => {
    const getBids = async () =>
      await getDocs(
        query(
          collection(db, `biddings`),
          where("type", "==", "bid"),
          where("status", "==", "won"),
          where("uid", "==", loggedUser.uid)
        )
      ).then((bidsData) => {
        const allBidsdata = bidsData.docs.map((item) => item.data());

        const getWinningBids = async () =>
          await getDocs(
            query(collection(db, `user_data/${loggedUser.uid}/images`))
          ).then((winBids) => {
            const winningBids = winBids.docs.map((item) => item.data());

            if (winningBids.length === 0) {
              setBids(allBidsdata.length > 0 ? allBidsdata : null);
            } else {
              const final = allBidsdata
                .map((item) =>
                  winningBids.find(
                    (itemm) => itemm.imageId === item.imageId
                  ) === undefined
                    ? item
                    : ""
                )
                .filter((item) => item !== "");
              setBids(final.length > 0 ? final : null);
            }
          });

        getWinningBids();
      });
    getBids();
  }, []);

  return bids && bids.length > 0 ? (
    <table className="table m-0">
      <thead>
        <tr className="text-white">
          <th>Image Id</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {bids.map((item, index) => (
          <tr key={index} className="text-white">
            <td>{item.imageId}</td>
            <td>${item.bid_amount}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : bids === null ? (
    <div className="text-center text-white py-4">No Recieved Found!</div>
  ) : (
    <div className="text-center py-4">
      <div className="spinner-border text-light" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default MadeSection;
